// Z-index constants for pinned rows
export const Z_INDEX = 1;
export const PINNED_ZINDEX = 1;
export const SUBMENU_VISIBLE_ZINDEX = 5;

// Row index constants
export const LAST_BOTTOM_ROW_INDEX = 1;

// Positioning constants
export const SUBMENU_VISIBLE_OFFSET = 2;
